export default {
  skip_to_main_content: 'Zum Hauptinhalt springen',
  show_system_messages: 'Systemnachrichten anzeigen',
  dont_show_system_messages: 'Systemnachrichten ausblenden',
  logged_in: 'Mieter ist authentifiziert',
  logged_out: 'Anonymer Nutzer',
  button_tooltip_switch_locale: 'Sprache ändern',
  button_tooltip_activate_voice_recognition: 'Spracherkennung aktivieren',
  date_input: 'Datum auswählen',
  date_range: 'Zeitspanne',
  from: 'von',
  to: 'bis',
  choose_two_dates: 'Bitte wählen Sie zwei Daten',
  avatar: 'Avatar',
  exit: 'Ende',
  new: 'Neu',
  back: 'Zurück',
  address: 'Adresse',
  suggestions: 'Vorschläge',
  senton: 'Gesendet am',
  message_placeholder: 'Nachricht hier eingeben...',
  message_aria: 'Nachricht hier eingeben',
  upload_in_progress: 'Upload läuft...',
  comment_placeholder: 'Kommentar hier eingeben',
  message_button_label: 'Senden',
  please_confirm: 'Bitte bestätigen',
  no: 'Nein',
  yes: 'Ja',
  modal_delete_session: 'Sitzung löschen',
  modal_delete_session_notification:
    'Wenn Sie das Fenster schließen, wird Ihre Sitzung ebenfalls gelöscht.<br>Sind Sie damit einverstanden?',
  template_contact_time: 'Wann dürfen wir Sie kontaktieren?',
  template_pause:
    'Ihre Sitzung wurde pausiert. In Kürze wird sich einer unserer Support-Mitarbeiter um Ihr Anliegen kümmern.',
  template_continue_after_pause:
    'Ihre Sitzung wurde fortgesetzt. Sie können nun weiter chatten.',
  choose_date: 'Bitte wählen Sie ein Datum',

  button_apply: 'Übernehmen',
  button_cancel: 'Abbrechen',
  none: 'Keine',
  book_appointment: 'Termin buchen',
  address_input: 'Adresse eingeben',
  data_processing: 'Datenverarbeitung',
  privacy_policy: 'Datenschutzerklärung',
  data_processing_notification_before_link:
    'Damit Sie diesen Chat-Service in Anspruch nehmen können, ist es notwendig, dass Sie die ',
  data_processing_notification_after_link: 'akzeptieren.',
  button_accept: 'Akzeptieren',
  select_date: 'Datum auswählen',
  rate_conversation: 'Wie würden Sie dieses Gespräch bewerten?',
  new_ticket_question: 'Kann ich sonst noch etwas für Sie tun?',
  thank_you:
    'Danke für Ihre Unterstützung. Ihr Feedback hilft mir, um mich stets zu verbessern.',
  goodbye: 'Bis bald',
  start_new: 'Neues Gespräch beginnen',
  operator_entered_the_chat: 'Mitarbeiter ist dem Chat beigetreten',
  operator_left_the_chat: 'Mitarbeiter hat den Chat verlassen',
  bg_image: process.env.VUE_APP_DE_BG,
  expand_quickreplies: 'Mehr',
  collapse_quickreplies: 'Weniger',
  login: 'Anmelden',
  logout: 'Abmelden',
  close: 'Schließen',
  messenger_text:
    'Sie können entweder mit unserem Chatbot schreiben oder in unserem Live Chat direkt mit einem unserer Mitarbeiter Kontakt aufnehmen.',
  chat_bot: 'Chatbot',
  live_bot: 'Live Chat',
  maximize: 'Maximieren',
  minimize: 'Minimieren',
  upload_file: 'Datei zum Hochladen hier ablegen',
  upload_file_or: 'oder',
  Upload_file_select: 'Dateien hinzufügen',
  upload_file_text: 'Datei ablegen um sie hochzuladen',
  show_attachments: 'Anhang anzeigen',
  hide_attachments: 'Anhang ausblenden',
  tooBig: 'Die Datei ist zu groß',
  fileTooLargeLimit: 'Die Datei ist zu groß. Maximale Größe pro Datei: 10 MB.',
  tooSmall: 'Die Datei ist zu klein',
  invalidFileTypeCopilot:
    'Ungültiger Dateityp. Momentan werden nur Dateitypen .png, .jpg, .jpeg, .gif unterstützt.',
  tooManyFiles: 'Bitte laden Sie maximal 10 Dateien auf einmal hoch',
  uploadError: 'Upload fehlgeschlagen. Bitte versuchen Sie es erneut.',
  maxDocumentsReached:
    'Maximale Anzahl an Dokumenten (10) für diese Konversation erreicht',
  no_text_content_detected: 'Kein Textinhalt in diesem Dokument erkannt',
  document_indexing_failed: 'Dokument konnte nicht indiziert werden',
  chatProtocol: 'ChatProtokoll',
  showMore: 'Mehr anzeigen',
  showLess: 'Weniger anzeigen',
  uploadTooltip: 'Datei hochladen',
  uploadFilesTooltip: 'Dateien hochladen',
  pdfDownloadTooltip: 'Konversation herunterladen',
  feedbackDescription: 'Anregungen an uns',
  feedbackPlaceholder: 'Nachricht hier eingeben...',
  feedbackInfoPlaceholder: 'Fügen Sie hier gerne spezifische Details hinzu...',
  feedbackSubtitle: {
    description:
      'Hier können Sie uns allgemeine Anregungen, Vorschläge und Wünsche mitteilen.',
    note: 'Bitte beachten Sie, dass wir darauf nicht antworten können.',
    hint:
      'Alle anderen Anliegen, die ganz konkret Ihr Mietverhältnis oder die Suche nach einer Wohnung betreffen, können Sie uns im Chat schildern.'
  },
  sendFeedback: 'Senden',
  giveFeedback: 'Anregungen an uns',
  feedbackSubmittedSuccessfully: 'Ihre Anregung wurde erfolgreich übermittelt',
  character_limit: 'Charakter',
  page: 'S.',
  factually_incorrect: 'Nicht faktisch korrekt',
  not_following_instructions: 'Anweisungen unvollständig befolgt',
  info_not_in_document: 'Gesuchte Information im Dokument nicht gefunden',
  inappropriate_or_offensive: 'Inhalt unangemessen oder beleidigend',
  irrelevant: 'Irrelevant',
  not_fitting_topic: 'Nicht zum Thema passend',
  confusing_information: 'Irreführende Information',
  ignored_important_parts_of_document: 'Wichtige Teile des Dokuments ignoriert',
  interpreted_document_wrong: 'Dokument nicht richtig interpretiert',
  answer_to_generic: 'Antwort zu allgemein',
  sources_incorrect: 'Quellen unzuverlässig oder falsch zitiert',
  why_not_helpful: 'Warum war das nicht hilfreich?',
  thank_you_feedback: 'Vielen Dank für Ihr Feedback!',
  provide_feedback: 'Feedback zur Antwort geben',
  not_helpful: 'Nicht hilfreich',
  helpful: 'Hilfreich',
  regenerate_message: 'Neu generieren',
  copy_message: 'Kopieren',
  copied_message: 'Kopiert!',
  copy_table_csv: 'Tabelle kopieren',
  download_table_csv: 'CSV herunterladen',
  expand_table: 'Tabelle öffnen',
  print: 'Drucken',
  original_answer: 'Original Antwort',
  regenerated_answer: 'Neu generierte Antwort',
  thinking_message: 'Ich denke nach...',
  file_path: 'Dateipfad: ',
  new_messages: 'Neue Nachrichten',
  previous_message: 'Vorherige Nachricht',
  next_message: 'Nächste Nachricht',
  clear_input: 'Eingabe löschen',
  open_feedback: 'Feedback öffnen',
  file_upload: 'Datei-Upload',
  remove_file: 'Datei entfernen',
  expand_quickreplies_aria: 'Mehr Buttons anzeigen',
  button_tooltip_switch_locale_german: 'Sprache auf Deutsch ändern',
  button_tooltip_switch_locale_french: 'Sprache auf Französisch ändern',
  button_tooltip_switch_locale_dutch: 'Sprache auf Niederländisch ändern',
  button_tooltip_switch_locale_turkish: 'Sprache auf Türkisch ändern',
  button_tooltip_switch_locale_russian: 'Sprache auf Russisch ändern',
  button_tooltip_switch_locale_swedish: 'Sprache auf Schwedisch ändern',
  button_tooltip_switch_locale_ukranian: 'Sprache auf Ukrainisch ändern',
  button_tooltip_switch_locale_spanish: 'Sprache auf Spanisch ändern',
  button_tooltip_switch_locale_polish: 'Sprache auf Polnisch ändern',
  button_tooltip_switch_locale_arabic: 'Sprache auf Arabisch ändern',
  button_tooltip_switch_locale_italian: 'Sprache auf Italienisch ändern',
  button_tooltip_switch_locale_english: 'Sprache auf Englisch ändern',
  message_from_you: 'Sie sagen',
  message_from_bot: 'Bot sagt',
  message_from_operator: 'Agent sagt',
  new_message_from_bot: 'Bot sagt',
  empty_message_received: 'Leere Nachricht empfangen',
  chat_messages: 'Chat-Nachrichten',
  ai_warning:
    'KI Antworten können ungenau sein. Überprüfen Sie wichtige Informationen sorgfältig.',
  file_type_pdf: 'PDF',
  file_type_image: 'Bild',
  file_type_word: 'Word',
  file_type_excel: 'Excel',
  file_type_powerpoint: 'PowerPoint',
  file_type_audio: 'Audio',
  file_type_video: 'Video',
  file_type_text: 'Text',
  file_type_csv: 'CSV',
  file_type_file: 'Datei',
  open_quick_actions: 'Schnellaktionen öffnen',
  quick_actions: 'Schnellaktionen',
  quick_actions_search_hint: '...oder schreiben Sie weiter für Vorschläge',
  quick_actions_no_results: 'Keine Einträge gefunden',
  add_files: 'Dateien hinzufügen',
  add_files_photos: 'Fotos & Dateien hinzufügen',
  add_files_photos_description: 'Dokumente und Bilder hochladen',
  canvas_action_label: 'Canvas',
  canvas_action_description: 'Dokument im Canvas erstellen und bearbeiten',
  canvas_armed_label: 'Canvas-Modus aktiv',
  canvas_armed_description: 'Die nächste Nachricht erstellt ein Dokument im Canvas',
  canvas_armed_disarm: 'Canvas-Modus deaktivieren',
  canvas_used_label: 'Canvas',
  canvas_used_title: 'Diese Nachricht hat den Canvas-Modus ausgelöst',
  canvas_card_copy: 'Kopieren',
  canvas_card_edit: 'Bearbeiten',
  canvas_card_download: 'Herunterladen',
  canvas_card_download_pdf: 'Als PDF',
  canvas_card_download_docx: 'Als Word',
  canvas_card_created: 'Dokument erstellt',
  canvas_card_updated: 'Dokument aktualisiert',
  canvas_card_image_created: 'Bild erstellt',
  canvas_card_image_updated: 'Bild aktualisiert',
  canvas_card_open_image: 'Im Canvas öffnen',
  scroll_left: 'Nach links scrollen',
  scroll_right: 'Nach rechts scrollen',
  prompt_apply: 'Anwenden',
  prompt_variables: 'Variablen',
  web_search_in_progress: 'Websuche läuft …'
}
